import React from 'react';
import { observer } from 'mobx-react';
import { FieldInputProps, FieldMetaState } from 'react-final-form';

import AppStorage from '../../Storage/Storage';
import Labels from '../../enums/Labels';
import { translate } from '../../utils/utils';
import { OptionValue } from '../../types/toggleOption';

import { TafToggleInput } from '@taf-ui/react';
import { Option, TafChangeEvent } from '@taf-ui/core';

type Props = {
  onChangeCallback(value: OptionValue): void;
  meta: FieldMetaState<string>;
  input: FieldInputProps<string>;
  label: Labels;
  labelAddition: string;
  tafToggleId?: string;
  options: Array<Option>;
} & Partial<DefaultProps>;

const defaultProps = {
  label: '',
  labelAddition: '',
};

type DefaultProps = Readonly<typeof defaultProps>;

class ToggleButtons extends React.PureComponent<Props> {
  private readonly storage: AppStorage;

  static defaultProps: DefaultProps = defaultProps;

  constructor(props: Props) {
    super(props);
    this.storage = AppStorage.getInstance();
  }

  changeHandler = (e: CustomEvent<TafChangeEvent<string>>): void => {
    const {
      input: { onChange },
      onChangeCallback,
    } = this.props;
    let value: string | boolean = e.detail.value;
    if (value === 'false') {
      value = false;
    }
    if (value === 'true') {
      value = true;
    }

    onChange(value);

    if (onChangeCallback) onChangeCallback(value);
  };

  render(): React.ReactElement {
    const {
      input,
      meta,
      label,
      labelAddition,
      options,
      tafToggleId = '',
    } = this.props;

    const locale = this.storage.getLocale;

    return (
      <TafToggleInput
        id={tafToggleId}
        label={labelAddition || translate(label, locale)}
        name={input.name}
        options={options}
        value={input.value}
        validationState={meta.error && meta.touched ? 'error' : undefined}
        validationMessage={translate(meta.error as Labels, locale)}
        onTafChange={this.changeHandler}
        className="rs_skip" //Todo: After migration to TAF UI, remove this className
      />
    );
  }
}

ToggleButtons.defaultProps = defaultProps;

export default observer(ToggleButtons);
